import React, { useContext, useState } from 'react';
import Icons from "../Icons/index";
import { useParams } from 'react-router-dom';
import { getData } from '../../lib/utils';
import { Context } from "../contexts/AppContext";

const PreviewHeader = ({setDevice}) => {
  const { galleryId } = useParams();

  const viewModes = [
    { name: 'mobile', icon: <Icons.Mobile />, label: 'Mobile' },
    { name: 'tablet', icon: <Icons.Ipad />, label: 'Tablet' },
    { name: 'desktop', icon: <Icons.Desktop />, label: 'Desktop' },
  ];
  
  const [viewMode, setViewMode] = useState('desktop');

  const handleButtonClick = (modeName) => {
    //console.log(`Clicked on ${modeName} view mode`);
    setViewMode(modeName)
    setDevice(modeName); // Set the view mode when clicked
  };

  const { value } = useContext(Context);
  const [appState, setAppState] = value; 

  window.onload = async()=> {
    //console.log("WINDOW---------")
    // alert(process.env.REACT_APP_TO_CLIENT)
    const url = window.location.pathname; // Get current URL path
    // Split the URL by '/' and extract the gallery ID
    const parts = url.split('/');
    const galleryId = parts[parts.indexOf('galleries') + 1]; 
    const response = await getData(`galleries/gallery/${galleryId}`);
    if(response)
    {
     console.log("PREVIEWHEADER.JS call api on windon load",response);
      const obj ={}
      obj.name=response.folder.name;
      obj.id=response.folder._id;
      obj.adminId=response.folder.adminId;
      obj.galleries=[response.gallery] 
      obj.gallery=response.gallery
      setAppState((prevState) => {
        return { ...prevState, 
           currentFolderData:obj,
           currentFolderName:obj.name,
           currentGalleryData:response.gallery,
           videoArr:response.videos,
           currentGalleryName:response.gallery.name,
           backgroundMedia:response.gallery.backgroundMedia
                        
        };
      });
    }
  
  } 

  return (
    <div className="border-b border-gray-300 p-4 flex flex-col md:flex-row md:items-center md:justify-between bg-white shadow-sm rounded-md">
      <h2 className="text-lg font-semibold mb-3 md:mb-0">PREVIEW</h2>

      <div className="flex flex-col md:flex-row items-center gap-4">
        <a
          href={`${process.env.REACT_APP_TO_CLIENT}${galleryId}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-yellow-800 text-yellow-800 hover:bg-blue-100 px-4 py-2 rounded-md transition duration-200"
        >
          <Icons.NewTap />
          New Tab
        </a>

        <div className="flex gap-2">
          {viewModes.map((mode) => (
            <button
              key={mode.name}
              onClick={() => handleButtonClick(mode.name)} // Call the function when the button is clicked
              className={`px-3 py-2 rounded-md border ${
                viewMode === mode.name
                  ? 'bg-yellow-800 text-white border-yellow-800'
                  : 'border-gray-300 text-gray-600 hover:bg-gray-100'
              }`}
            >
              {mode.icon}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PreviewHeader;
